import { Box, Card, Typography } from '@mui/material'
import React, { useState, useMemo } from 'react'
import nodata from '../../../../assest/images/No data-pana.svg'
import { useNavigate } from 'react-router-dom';

const ProjectStatusCard = ({ milestoneTable }) => {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const navigate = useNavigate();

    const handleProjectClick = (projectId) => {
        navigate("/project-dashboard", { state: { id: projectId } }); 
    };

    const containerStyle = {
        maxHeight: "390px",
        overflowY: "auto",
        overflowX: "hidden",
        borderRadius: "3px",
        // border: "1px solid #ddd",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        width: "100%",
    };

    const tableStyle = {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        fontFamily: "Arial, sans-serif",
        fontSize: "10px",
    };

    const thTdStyle = {
        border: "1px solid #ddd",
        padding: "12px 15px",
        textAlign: "left",
        backgroundColor: "white",
    };

    const headerStyle = {
        ...thTdStyle,
        position: "sticky",
        top: 0,
        backgroundColor: "#004a78",
        color: "white",
        fontWeight: "bold",
        zIndex: 1,
        cursor: "pointer",
    };

    const rowEvenStyle = { backgroundColor: "#f9f9f9" };
    const rowHoverStyle = { backgroundColor: "#f1f1f1" };

    const getPriorityStyle = (priority) => {
        switch (priority) {
            case "critical":
                return { color: "#f44336", fontWeight: "bold" };
            case "medium":
                return { color: "#ff9800", fontWeight: "bold" };
            case "high":
                return { color: "#4caf50", fontWeight: "bold" };
            default:
                return {};
        }
    };

    // Sorting logic
    const sortedData = useMemo(() => {
        let sortableData = [...(milestoneTable?.milestone_details || [])];
        if (sortConfig.key !== null) {
            sortableData.sort((a, b) => {
                const aVal = a[sortConfig.key];
                const bVal = b[sortConfig.key];

                if (typeof aVal === "number" && typeof bVal === "number") {
                    return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
                } else {
                    return sortConfig.direction === "asc"
                        ? aVal.toString().localeCompare(bVal.toString())
                        : bVal.toString().localeCompare(aVal.toString());
                }
            });
        }
        return sortableData;
    }, [milestoneTable, sortConfig]);

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    return (
        <Card sx={{ padding: 1, height: '423px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant='h6' fontWeight='bold' color='dark'>
                    {milestoneTable?.milestone_title}
                </Typography>
                <div style={containerStyle} className="hide-scroll">
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th
                                    style={headerStyle}
                                    onClick={() => handleSort("project_name")}
                                >
                                    Project {sortConfig.key === "project_name" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                                </th>
                                <th style={{ ...headerStyle, cursor: "default" }}>Milestone</th>
                                <th
                                    style={headerStyle}
                                    onClick={() => handleSort("progress")}
                                >
                                    Progress {sortConfig.key === "progress" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                                </th>
                                <th style={{ ...headerStyle, cursor: "default" }}>Priority</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedData.length > 0 ? (
                                sortedData.map((row, index) => (
                                    <tr
                                        key={index}
                                        style={index % 2 === 0 ? rowEvenStyle : {}}
                                        onMouseEnter={(e) =>
                                        (e.currentTarget.style.backgroundColor =
                                            rowHoverStyle.backgroundColor)
                                        }
                                        onMouseLeave={(e) =>
                                        (e.currentTarget.style.backgroundColor =
                                            index % 2 === 0 ? rowEvenStyle.backgroundColor : "")
                                        }
                                    >
                                        <td style={{ ...thTdStyle, cursor: "pointer", color: "#004a78", fontWeight: 600 }} onClick={() => handleProjectClick(row.id)}>{row.project_name}</td>
                                        <td style={thTdStyle}>{row.milestone_name}</td>
                                        <td style={thTdStyle}>{row.progress}</td>
                                        <td style={{ ...thTdStyle, ...getPriorityStyle(row.priority) }}>
                                            {row.priority}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={4}
                                        style={{
                                            textAlign: "center",
                                            padding: "25px",
                                            fontSize: "15px",
                                            color: "#555",
                                            fontStyle: "italic",
                                            border: "1px solid #ddd",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            <img
                                                src={nodata}
                                                alt="No data"
                                                style={{ width: "100px", height: "100px" }}
                                            />
                                            <span style={{ fontSize: "14px", fontFamily: "Arial, sans-serif" }}>No project data found</span>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <style>
                        {`
                          .hide-scroll::-webkit-scrollbar {
                            display: none;
                          }
                        `}
                    </style>
                </div>
            </Box>
        </Card>
    )
}

export default ProjectStatusCard
